<template>
<div class="outpatientService">
  <div class="topBarBox" v-if="topBarList.length!==0">
    <div class="topBarMarsk"></div>
    <div class="topBar" >
      <div @click="activeTopBar(item.id)" :class="barActive===item.id?'activeBaritem':'barItem'" v-for="item in topBarList" :key="item.id">
        <div class="label">
          {{item.label}}
          <div class="indicator"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="leftBox">
      <leftListTab ref="leftListTab" @getPatientInfo="getPatientInfo" />
    </div>
    <div class="rightBox">
      <outpatientServiceContent ref="outpatientServiceContent" :userInfoData="userInfo" @refresh-list="refreshList"/>
    </div>
  </div>

</div>
</template>

<script>
import {topBarList} from "@/views/outpatientDoctorWorkstation/outpatientService/staticData";
import leftListTab from "@/views/outpatientDoctorWorkstation/outpatientService/components/leftListTab";
import outpatientServiceContent from "@/views/outpatientDoctorWorkstation/outpatientService/components/outpatientServiceContent";
import {get} from "@/api/api";
function getCurrentDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export default {
  name: "outpatientService",
  data() {
    return {
      topBarList,
      barActive: 2,
      userInfo: {},
      medicalRecordId:null,
      visitState:null,
    }
  },
  components: {
    leftListTab,
    outpatientServiceContent
  },
  async beforeRouteLeave (to, from, next) {
    console.log('hhhhhhhhhh', this.$refs.outpatientServiceContent)
    if (this.$store.state.aiDiagnosisList.length > 0) {
      try {
        await this.$refs.outpatientServiceContent.handleBeforeUnload()
        next()
      } catch (error) {
        console.error('预诊提交失败:', error)
        next()
      }
    } else {
      next()
    }

  },
  methods:{
    getOne(caseNumber) {
      get('/outpatientDoctor/patient/getOne', {caseNumber: caseNumber}).then(res=>{
        this.userInfo = res.data.data
        this.userInfo.medicalRecordId = this.medicalRecordId
        this.userInfo.visitState = this.visitState
        this.userInfo.visitDate = getCurrentDate()
      })
    },
    getPatientInfo (item) {
      console.log('iiiiii'+item.visitState !== '00', item)
      if (item.visitState !== '00') {
        this.medicalRecordId = item.medicalRecordId
        this.visitState = item.visitState
        this.getOne(item.caseNumber)
      } else {
        this.userInfo = {
          ...item,
          draftId: item.draftId,
          address: item.address || '',
          ageDays: item.ageDays || '',
          ageMonth: item.ageMonth || '',
          ageYear: item.ageYear || '',
          birthday: item.birthday || '',
          caseNumber: item.caseNumber || '',
          cityCode: item.cityCode || '',
          creator: 1,
          districtCode: item.districtCode || '',
          districtName: item.districtName || '',
          gender: item.gender?item.gender:'NAN',
          idNumber: item.idNumber || '',
          isValid: 1,
          job: item.job || '',
          marriage: item.marriage || '',
          name: item.name,
          nationnality: item.nationnality || '',
          phoneNumber: item.phoneNumber || '',
          updator: 1,
          weight: item.weight || '',
          visitState:item.visitState,
          visitDate:getCurrentDate()
        }
        if (this.userInfo && (this.userInfo.ageYear || this.userInfo.ageMonth || this.userInfo.ageDays)) {
          this.userInfo.birthday = this.$calculateBirthDate(this.userInfo.ageYear,this.userInfo.ageMonth,this.userInfo.ageDays)
        }
      }

    },
    activeTopBar (id) {
      this.barActive = id
    },
    refreshList() {
      console.log('调用refreshList方法')
      // 获取leftListTab组件的引用
      const leftListTabRef = this.$refs.leftListTab;
      if (leftListTabRef) {
        // 获取当前选中的患者信息
        const currentPatient = this.$store.state.nowPatientInfo;
        console.log('刷新列表时的当前患者:', currentPatient);

        // 重置页码并刷新列表，传入当前患者信息以便在刷新后选中该患者
        // 设置autoSelect为false，避免自动选中第一个患者
        leftListTabRef.pageNum = 1;

        // 确保leftListTab组件中的标志位被正确设置
        leftListTabRef.isRefreshingFromWatch = true;
        console.log('设置isRefreshingFromWatch标志位为true');

        try {
          console.log('开始调用queryOutpatientFormList方法...');
          leftListTabRef.queryOutpatientFormList(false, currentPatient, false);
        } catch (error) {
          console.error('刷新列表失败:', error);
          this.$message.error('刷新患者列表失败，请稍后重试');
          // 确保leftListTab组件中的标志位被重置
          if (leftListTabRef.isRefreshingFromWatch) {
            leftListTabRef.isRefreshingFromWatch = false;
            console.log('重置isRefreshingFromWatch标志位为false');
          }
          if (leftListTabRef.isInitializing) {
            leftListTabRef.isInitializing = false;
            console.log('重置isInitializing标志位为false');
          }
        }
      } else {
        console.warn('未找到leftListTab组件引用');
      }
    }
  }
}
</script>

<style lang="less" scoped>

.outpatientService{
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  background-color: rgb(245,245,245);
  font-size: 14px;
  //overflow: auto;
  .topBarBox{
    position: relative;
    transform: translateZ(0);
    .topBarMarsk{
      height: 48px;
      width: 100%;
    }
    .topBar{
        display: flex;
        background: linear-gradient(135deg, #8B4513 0%, #CD853F 100%);
        height: 48px;
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        color: #F5DEB3;
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(139, 69, 19, 0.3);
      .barItem{
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;
        padding: 4px 15px;

        .label{
          padding-bottom: 5px;
          .indicator{
            display: none;
          }
        }
      }
      .barItem:hover{
          background: rgba(220, 20, 60, 0.2);
          border-radius: 5px;
          color: #FFD700;
        }
      .activeBaritem{
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: center;
        padding: 4px 15px;

        .label{
          font-weight: bold;
          //border: 1px solid red;
          position: relative;
          padding-bottom: 5px;
          cursor: pointer;
          .indicator{
            background-color: #DC143C;
            height: 3px;
            width: 100%;
            position: absolute;
            bottom: 0px;
          }
        }
      }
      .activeBaritem:hover{
          background: rgba(220, 20, 60, 0.2);
          border-radius: 5px;
          color: #FFD700;
        }
    }
  }
  .content{
    flex: 1;
    //border: 1px solid red;
    display: flex;
    align-items: center;
    .leftBox{
      height: 100%;
      max-width: 14vw;
    }
    .rightBox{
      flex: 1;
      height: 100%;
      display: flex;
    }
  }
}
</style>
